<template>
  <div class="connect-us" :style="{ position: popoverStyles ? 'static' : undefined }" @click.stop>
    <div class="trigger-hover"><slot></slot></div>
    <div class="popover-container" :style="popoverStyles">
      <div class="connect-us-popover">
        <div class="phone">咨询电话：<span class="text-primary">025-66678988</span></div>
        <img class="qr-code" src="@/assets/img/qrcode/official_accounts.png">
        <div class="remark">扫码关注公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popoverStyles: null
    }
  },
  mounted() {

  },
  methods: {
    open(e) {
      e.stopPropagation();
      this.popoverStyles = {
        display: 'block',
        transform: 'none',
        left: e.pageX + 'px',
        top: e.pageY + 'px',
      };
      document.body.addEventListener('click', this.close);
    },
    close() {
      this.popoverStyles = null;
      document.body.removeEventListener('click', this.close);
    },
  }
}
</script>

<style lang="less" scoped>
.connect-us {
  display: inline-block;
  position: relative;
  .trigger-hover:hover + .popover-container {
    display: block;
  }
  .popover-container {
    padding-bottom: 12px;
    display: none;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    &:hover {
      display: block;
    }
    .connect-us-popover {
      width: 198px;
      height: 198px;
      background: #FFFFFF;
      box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.1);
      border-radius: 4px 4px 4px 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .phone {
        font-family: @font-medium;
        font-size: 14px;
      }
      .qr-code {
        width: 120px;
        height: 120px;
      }
      .remark {
        font-size: 14px;
      }
    }
  }
}
</style>
